import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { NavService } from '../../services/nav.service';
import { ThemesService } from '../../features/setting/services/themes.service';

@Component({
  selector: 'app-dial-screen',
  templateUrl: './dial-input-update.component.html',
})
export class DialScreenComponent implements OnInit, AfterViewInit {
  @Input() number = '';
  @Output() numberChange = new EventEmitter<string>();
  @Output() onRemove = new EventEmitter();
  @ViewChild('myInput') private _inputElement!: ElementRef;

  constructor(public themeService: ThemesService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this._inputElement.nativeElement.focus();
  }

  onNumberChange(value: any) {
    this.numberChange.emit(value);
  }
  onNumberRemove(): void {
    this.onRemove.emit();
  }
  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let number = clipboardData?.getData('text') || '';
    number = number.trim(); // remove whitespace/newlines
    number = number.replace(/\D/g, ''); // remove non-digits
    if (number.length > 10) {
      event.preventDefault();
      if (number.substring(0, 2) == '+1') {
        number = number.substring(2, number.length);
      } else if (number.substring(0, 1) == '+' || number.substring(0, 1) == '1') {
        number = number.substring(1, number.length);
      }
      this.numberChange.emit(number);
    }
  }
}
